import { axios, axiosMocking } from "../http-common";
import DB from '../util/DB';

class Common {
  paymentAccount() {
    return axios.get("v1/member/reference/payment-account");
  }
  transaction(data) {
    return axios.get("v1/member/transaction/cardtransaction", {
      params: data
    });
  }
  
  // async profile(forceRefresh = false) {

  //   const cacheKey = 'profile';

  //   const cached = await DB.get(cacheKey);
  //   if (cached && !forceRefresh) {
  //     if (typeof onUpdate === 'function') {
  //       onUpdate(cached.data);
  //     }

  //     axios.get("v1/member/profile").then(async (response) => {
  //       if (response.status === 200) {
  //         const newData = response.data.data;

  //         if (JSON.stringify(newData) !== JSON.stringify(cached.data)) {
  //           await DB.save(cacheKey, { data: newData, cachedAt: Date.now() });

  //           if (typeof onUpdate === 'function') {
  //             onUpdate(newData);
  //           }
  //         }
  //       }
  //     });

  //     return { status: 200, data: { data: cached.data } };
  //   }

  //   // Tidak ada cache atau force refresh
  //   const response = await axios.get("v1/member/profile");
  //   if (response.status === 200) {
  //     await DB.save(cacheKey, { data: response.data.data, cachedAt: Date.now() });
  //   }

  //   return response;
  // }
  getResetPin(params) {
    return axios.get("v1/member/card/reset-pin",{params});
  }
  profile() {
    return axios.get("v1/member/profile");
  }
  submitSignature(data){
    return axios.post("v1/member/card/reset-pin?card_id="+data['card_id']+"&card_account_id="+data['card_account_id'], {"signature":data['signature']});
  }
  kyc(data) {
    return axios.post("v1/member/profile/kyc", data);
  }
  newKyc(data) {
    return axios.post("v1/member/profile/kycnew", data);
  }
  getKyc() {
    return axios.get("v1/member/profile/member-kyc");
  }
  job() {
    return axios.get("v1/member/job");
  }
  annual_income() {
    return axios.get("v1/member/annual-income-range");
  }
  update_profile(data) {
    return axios.post("v1/member/profile/update-profile-tab", {
      UpdateProfileTab: data
    });
  }
  update_email(data) {
    return axios.post("v1/member/profile/change-email-request", data);
  }

  card_details(data){
    return axios.post("v1/member/card/detail", data);
  }

  resubmit_application(data) {
    return axios.post("v1/member/profile/resubmit-kyc", data);
  }

  async card_list({ params = {}, forceRefresh = false, onUpdate = null } = {}) {
    const cacheKey = 'card_request';

    const cached = await DB.get(cacheKey);
    if (cached && cached.data && !forceRefresh) {
      if (typeof onUpdate === 'function') {
        onUpdate(cached.data);
      }

      axios.get("v1/member/card-request", { params }).then(async (response) => {
        if (response.status === 200) {
          const newData = response.data.data;

          if (JSON.stringify(newData) !== JSON.stringify(cached.data)) {
            await DB.save(cacheKey, { data: newData, cachedAt: Date.now() });

            if (typeof onUpdate === 'function') {
              onUpdate(newData);
            }
          }
        }
      });

      return { status: 200, data: { data: cached.data } };
    }

    // Tidak ada cache atau force refresh
    const response = await axios.get("v1/member/card-request", { params });
    if (response.status === 200) {
      await DB.save(cacheKey, { data: response.data.data, cachedAt: Date.now() });
    }

    return response;
  }

  async card_list_utgl({ params = {}, forceRefresh = false, onUpdate = null } = {}) {
    const cacheKey = 'card_list';

    const cached = await DB.get(cacheKey);
    if (cached && !forceRefresh) {
      if (typeof onUpdate === 'function') {
        onUpdate(cached.data);
      }

      axios.get("v1/member/transaction/cardlist", { params }).then(async (response) => {
        if (response.status === 200) {
          const newData = response.data.data;

          if (JSON.stringify(newData) !== JSON.stringify(cached.data)) {
            await DB.save(cacheKey, { data: newData, cachedAt: Date.now() });

            if (typeof onUpdate === 'function') {
              onUpdate(newData);
            }
          }
        }
      });

      return { status: 200, data: { data: cached.data } };
    }

    // Tidak ada cache atau force refresh
    const response = await axios.get("v1/member/transaction/cardlist", { params });
    if (response.status === 200) {
      await DB.save(cacheKey, { data: response.data.data, cachedAt: Date.now() });
    }

    return response;
  }

  async card_active({forceRefresh = false, onUpdate = null } = {}) {
    const cacheKey = 'card_active';

    const cached = await DB.get(cacheKey);
    if (cached && !forceRefresh) {
      if (typeof onUpdate === 'function') {
        onUpdate(cached.data);
      }

      axios.get("v1/member/topup/card-list").then(async (response) => {
        if (response.status === 200) {
          const newData = response.data.data;

          if (JSON.stringify(newData) !== JSON.stringify(cached.data)) {
            await DB.save(cacheKey, { data: newData, cachedAt: Date.now() });

            if (typeof onUpdate === 'function') {
              onUpdate(newData);
            }
          }
        }
      });

      return { status: 200, data: { data: cached.data } };
    }

    // Tidak ada cache atau force refresh
    const response = await axios.get("v1/member/topup/card-list");
    if (response.status === 200) {
      await DB.save(cacheKey, { data: response.data.data, cachedAt: Date.now() });
    }

    return response;
  }

  email_activation(data){
    return axios.get("v1/member/profile/email-activation", {params:data});
  }
  
  card_req(data) {
    return axios.post("v1/member/card-request", { CardRequest: data });
  }

  card_req_family(data) {
    return axios.post("v1/member/family/add", data);
  }

  card_req_new(data, file) {
    const params = file
      ? { CardRequest: data, CardRequestFile: file }
      : { CardRequest: data };
    return axios.post("v1/member/card-request/new", params);
  }

  card_unavailable() {
    return axios.get("v1/member/card/currency-unavailable");
  }

  request_cancel_card(data) {
    return axios.post("v1/member/chat/request-cancel-card", data);
  }

  activate(data) {
    return axios.post("v1/member/card/activate", data);
  }

  activatePhysical(data) {
    if(data.card_type=="virtual-mastercard"){
      return axios.post("v1/member/card/activate", {
        card_number:data['card_number']
      });  
    }
    else{
      return axios.post("v1/member/card/activation-phisycal", 
        {
          card_number:data['card_number'],
          cvv:data['cvv'],
          exp:data['exp']
        });
    }
  }

  request_lock_unlock(data) {
    if (data.status == 1) {
      return axios.post("v1/member/card/lock", {
        card_number: data.card_number
      });
    } else {
      return axios.post("v1/member/card/un-lock", {
        card_number: data.card_number
      });
    }
  }
  change_atm_pin(data) {
    return axios.post("v1/member/card/change-atm-pin", data);
  }

  cancel_reason() {
    return axios.get("v1/member/reference/cancel-reason");
  }

  balance(payload) {
    return axios.get("v1/member/card/balance", {
      params: payload
    });
  }


  async countries(forceRefresh = false) {
    const cacheKey = 'countries';

    if (!forceRefresh) {
      const data = await DB.get(cacheKey);
      if (data) {
        return { status: 200, data: { data } };
      }
    }

    const response = await axios.get("v1/member/reference/countries");
    if (response.status === 200) {
      await DB.save(cacheKey, response.data.data);
    }

    return response;
  }

  async states(params = {}, forceRefresh = false) {
    const cacheKey = 'states_' + JSON.stringify(params);

    if (!forceRefresh) {
      const cachedData = await DB.get(cacheKey);
      if (cachedData) {
        return { status: 200, data: { data: cachedData } };
      }
    }

    const response = await axios.get("v1/member/reference/states", { params: params });
    if (response.status === 200) {
      await DB.save(cacheKey, response.data.data);
    }

    return response;
  }

  async cities(params = {}, forceRefresh = false) {
    const cacheKey = 'cities_' + JSON.stringify(params);

    if (!forceRefresh) {
      const cachedData = await DB.get(cacheKey);
      if (cachedData) {
        return { status: 200, data: { data: cachedData } };
      }
    }

    const response = await axios.get("v1/member/reference/cities", { params: params });
    if (response.status === 200) {
      await DB.save(cacheKey, response.data.data);
    }

    return response;
  }

  async get_fee({forceRefresh = false, onUpdate = null } = {}) {
    const cacheKey = 'provider_fee';

    const cached = await DB.get(cacheKey);
    if (cached && !forceRefresh) {
      if (typeof onUpdate === 'function') {
        onUpdate(cached.data);
      }

      axios.get("v1/member/reference/provider-fee").then(async (response) => {
        if (response.status === 200) {
          const newData = response.data.data;

          if (JSON.stringify(newData) !== JSON.stringify(cached.data)) {
            await DB.save(cacheKey, { data: newData, cachedAt: Date.now() });

            if (typeof onUpdate === 'function') {
              onUpdate(newData);
            }
          }
        }
      });

      return { status: 200, data: { data: cached.data } };
    }

    // Tidak ada cache atau force refresh
    const response = await axios.get("v1/member/reference/provider-fee");
    if (response.status === 200) {
      await DB.save(cacheKey, { data: response.data.data, cachedAt: Date.now() });
    }

    return response;
  }

  async get_language(forceRefresh = false) {
    const cacheKey = 'language';

    if (!forceRefresh) {
      const data = await DB.get(cacheKey);
      if (data) {
        return { status: 200, data: { data } };
      }
    }

    const response = await axios.get("v1/member/reference/lang");
    if (response.status === 200) {
      await DB.save(cacheKey, response.data.data);
    }

    return response;
  }

  set_language(data) {
    return axios.post("v1/member/profile/update-language", {
      UpdateProfileTab: data
    });
  }

  // begin::FAQs
  faqs(data) {
    return axios.get("v1/member/faq", { params: data });
  }
  tags() {
    return axios.get("v1/member/faq/tags");
  }
  setPin(data) {
    return axios.post("v1/member/card/change-pin", data);
  }
  createEwallet(data) {
    return axios.post("v1/wallet/wallet/create", data);
  }
  depositEwallet(data) {
    return axios.post("v1/wallet/wallet/topup", data);
  }
  transferEwallet(data) {
    return axios.post("v1/wallet/wallet/transfer", data);
  }
  walletList() {
    return axios.post("v1/wallet/wallet/list");
  }
  detailWalletList(data) {
    return axios.post("v1/wallet/wallet/view", data);
  }
  topUpCardList(data) {
    return axios.get("v1/wallet/wallet/topup-list", data);
  }
  dataTransferList(data) {
    return axios.get("v1/wallet/wallet/transfer-list", data);
  }
  card_topup(payload) {
    return axios.post("v1/member/topup", payload);
  }
  // end::FAQs
}

export default new Common();
